<template>
    <b-container class="byc-font-size">
        <div class="byc-container ">
            <b-row>
                <b-col>
                    <div class="text-right mt-3">
                        <a :class="[isJACareerEntrepreApp ? 'skip-green-dark' : 'skip-green-light']" class="skip-link" @click="skip()" tabindex="0" role="button">Skip</a>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="title" tabindex="0" cols="12">
                       Before you continue...
                </b-col>
                <b-col  class="sub-title" tabindex="0" cols="12">
                   Lets review where you left off.
                 </b-col>
            </b-row>
            <Carousel @done="skip">
                <CarouselItem>
                    <div class="project-status-item">
                        <project-status
                                :index="$route.params.index"
                                :project="project"
                                :show-actions="false"
                        />
                    </div>
                   <div class="divider">
                       <hr/>
                   </div>
                    <div class="project-carousel-item">
                        <b-col cols="12" class="section-title">
                            {{getMessage(2, 'empathy-map-title')}}<span class="sr-only">.</span>
                        </b-col>
                        <question v-if="project['problem']"
                                  :label="getMessage(1, 'project-problem')">{{ printTextOrBlank(project['problem']) }}
                        </question>
                        <question v-if="project['customer']"
                                  :label="getMessage(1, 'project-customer')">{{ printTextOrBlank(project['customer']) }}
                        </question>
                        <question v-if="project.forms[Steps.FORM_EMPATHY_MAP]"
                                  :label="getMessage(4, 'empathy-map-sub')">
                            <item :label="getMessage(4, 'firstThing')"
                                  :text="project.forms[Steps.FORM_EMPATHY_MAP].firstThing"/>
                            <item :label="getMessage(4, 'secondThing')"
                                  :text="project.forms[Steps.FORM_EMPATHY_MAP].secondThing"/>
                            <item :label="getMessage(4, 'thirdThing')"
                                  :text="project.forms[Steps.FORM_EMPATHY_MAP].thirdThing"/>
                        </question>
                    </div>
                </CarouselItem>
                <CarouselItem v-if="project.forms[Steps.FORM_CUSTOMER_PROBLEM] || project.forms[Steps.FORM_IDEAL_STATE]">
                    <div class="project-carousel-item">
                        <question v-if="project.forms[Steps.FORM_CUSTOMER_PROBLEM]"
                                  :label="getMessage(5, 'empathy-map-sub')">
                            <item :label="getMessage(5, 'iam')"
                                  :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].iam"/>
                            <item :label="getMessage(5, 'tryingto')"
                                  :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].tryingto"/>
                            <item :label="getMessage(5, 'but')"
                                  :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].but"/>
                            <item :label="getMessage(5, 'because')"
                                  :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].because"/>
                            <item :label="getMessage(5, 'emotions')"
                                  :text="project.forms[Steps.FORM_CUSTOMER_PROBLEM].emotions"/>
                        </question>
                        <question v-if="project.forms[Steps.FORM_IDEAL_STATE]"
                                  :label="getMessage(6, 'empathy-map-sub')">
                            <item :label="getMessage(6, 'perfectWorld')"
                                  :text="project.forms[Steps.FORM_IDEAL_STATE].perfectWorld"/>
                            <item :label="getMessage(6, 'benefit')"
                                  :text="project.forms[Steps.FORM_IDEAL_STATE].benefit"/>
                            <item :label="getMessage(6, 'emotions')"
                                  :text="project.forms[Steps.FORM_IDEAL_STATE].emotions"/>
                        </question>
                    </div>
                </CarouselItem>
                <CarouselItem v-if="project.forms[Steps.FORM_BRAINSTORMING]">
                    <b-col cols="12" class=" mt-3 section-title"
                           v-if="project.forms[ Steps.FORM_BRAINSTORMING]">
                        {{getMessage(7, 'gobroadtogonarrow-title')}}<span class="sr-only">.</span>
                    </b-col>
                    <question v-if="project.forms[ Steps.FORM_BRAINSTORMING]"
                              :label="getMessage(9, 'gobroadtogonarrow-sub')">
                        <item :label="getMessage(9, 'who')"
                              :text="project.forms[Steps.FORM_BRAINSTORMING].who"/>
                        <item :label="getMessage(9, 'rounds')"
                              :text="project.forms[Steps.FORM_BRAINSTORMING].rounds"/>
                        <item :label="getMessage(9, 'ideas')"
                              :text="project.forms[Steps.FORM_BRAINSTORMING].ideas"/>
                    </question>
                </CarouselItem>
                <CarouselItem v-if="project.forms[Steps.FORM_TOP_IDEAS] || project.forms[Steps.FORM_SKETCH]">
                    <div class="project-carousel-item">
                        <question v-if="project.forms[Steps.FORM_TOP_IDEAS]"
                                  :label="getMessage(11, 'gobroadtogonarrow-sub')">
                            <item :label="getMessage(11, 'firstIdea')"
                                  :text="project.forms[Steps.FORM_TOP_IDEAS].firstIdea"/>
                            <item :label="getMessage(11, 'secondIdea')"
                                  :text="project.forms[Steps.FORM_TOP_IDEAS].secondIdea"/>
                            <item :label="getMessage(11, 'thirdIdea')"
                                  :text="project.forms[Steps.FORM_TOP_IDEAS].thirdIdea"/>
                        </question>
                        <question v-if="project.forms[Steps.FORM_SKETCH]"
                                  :label="getMessage(12, 'gobroadtogonarrow-sub')">
                            <item :label="getMessage(12, 'problem')"
                                  :text="project.forms[Steps.FORM_SKETCH].problem"/>
                        </question>
                        <question v-if="image"
                                  :label="getMessage(12, 'sketch')">
                            <img class="sketch-image"
                                 v-if="image"
                                 :src="image" alt="Sketch">
                            <span v-else>blank</span>
                        </question>
                    </div>
                </CarouselItem>
                <CarouselItem v-if="project.forms[Steps.FORM_LOF_ASSUMPTIONS]">
                    <div class="project-carousel-item">
                        <b-col cols="12" class="mt-3 section-title"
                               v-if="project.forms[Steps.FORM_LOF_ASSUMPTIONS]">
                            {{getMessage(13, 'rapidexperiment-title')}}<span class="sr-only">.</span>
                        </b-col>
                        <question v-if="project.forms[Steps.FORM_LOF_ASSUMPTIONS]"
                                  :label="getMessage(14, 'rapidexperiment-sub')">
                            <item :label="getMessage(14, 'firstAssumption')"
                                  :text="project.forms[Steps.FORM_LOF_ASSUMPTIONS].firstAssumption"/>
                            <item :label="getMessage(14, 'secondAssumption')"
                                  :text="project.forms[Steps.FORM_LOF_ASSUMPTIONS].secondAssumption"/>
                            <item :label="getMessage(14, 'thirdAssumption')"
                                  :text="project.forms[Steps.FORM_LOF_ASSUMPTIONS].thirdAssumption"/>
                        </question>
                        <question v-if="project.forms[Steps.FORM_HYPOTHESIS]"
                                  :label="getMessage(16, 'rapidexperiment-sub')">
                            <item :label="getMessage(16, 'if')"
                                  :text="project.forms[Steps.FORM_HYPOTHESIS].if"/>
                            <item :label="getMessage(16, 'then')"
                                  :text="project.forms[Steps.FORM_HYPOTHESIS].then"/>
                            <item :label="getMessage(16, 'measure')"
                                  :text="project.forms[Steps.FORM_HYPOTHESIS].measure"/>
                            <item :label="getMessage(16, 'metric')"
                                  :text="project.forms[Steps.FORM_HYPOTHESIS].metric"/>
                        </question>
                    </div>
                </CarouselItem>
                <CarouselItem v-if="project.forms[Steps.FORM_DEBRIEF_EXPERIMENT]">
                    <div class="project-carousel-item">
                        <question v-if="project.forms[Steps.FORM_DEBRIEF_EXPERIMENT]"
                                  :label="getMessage(18, 'rapidexperiment-sub')">
                            <item :label="getMessage(18, 'people')"
                                  :text="project.forms[Steps.FORM_DEBRIEF_EXPERIMENT].people"/>
                            <item :label="getMessage(18, 'worked')"
                                  :text="project.forms[Steps.FORM_DEBRIEF_EXPERIMENT].worked"/>
                            <item :label="getMessage(18, 'didntWork')"
                                  :text="project.forms[Steps.FORM_DEBRIEF_EXPERIMENT].didntWork"/>
                        </question>
                    </div>
                </CarouselItem>
            </Carousel>
        </div>
    </b-container>
</template>

<script>
    import ProjectYouContinue from "../../../core/Mixins/ProjectYouContinue";
    import {Steps} from "../Utils";

    export default {
        name: "BeforeYouContinue",
        mixins: [ProjectYouContinue],
        created() {
            this.Steps = Steps
        },
        methods: {
            skip() {
                let redirection = 'deep_customer_empathy_2'
                if (this.project.lastStep >= 2) {
                    const nextStep = this.project.lastStep + 1
                    switch (nextStep) {
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                            redirection = `deep_customer_empathy_${nextStep}`
                            break
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                            redirection = `go_broad_to_go_narrow_${nextStep}`
                            break
                        case 13:
                        case 14:
                        case 15:
                        case 16:
                        case 17:
                        case 18:
                        case 19:
                            redirection = `rapid_experiments_with_customers_${nextStep}`
                            break
                    }
                }
                const index = this.$route.params.index
                this.$router.push({name: redirection, params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .container
        margin-top 0
    +for_breakpoint(xs sm md)
        .container
            padding 0

    .byc-container
        background-color color-1
        padding 20px 10px
        box-sizing border-box
        height 100vh
        overflow hidden

    .skip-link
        padding-right 19px
        font font-poppins-semibold
        font-size 16px
        letter-spacing 0.8px
        cursor pointer

        &.skip-green-light
            color color-5
            &:hover
                color color-5

        &.skip-green-dark
            color color-green-light
            &:hover
                color color-green-dark


        .title
            padding 0 29px
            font font-poppins-semibold
            letter-spacing 0.53px
            font-size 21px
            color black

        .sub-title
            padding 0  29px 10px 29px
            font font-sourcesans-regular
            font-size 16px
            color color-4

        .project-status-item
            border 0
            box-shadow none
            margin-bottom 0
            padding 0 25px
        .divider
            hr
                color black
                margin-top 0

        .section-title
            font font-poppins-bold
            font-size 16px
            color black
            letter-spacing 0.4px

        .sketch-image
            max-width: 98%
            max-height: 60vh

</style>
